const commonErrorHelpListItems = {
    checkSpellingAndCapitalization:
        'Verifique la ortografía y las mayúsculas para asegurarse de que está ingresando la información correctamente.',
    contactSystemAdministratorIfStillUnableToAccess:
        'Póngase en contacto con el administrador del sistema si aún no puede acceder al sitio web.',
    contactSystemAdministratorForAssistance: 'Póngase en contacto con el administrador del sistema para obtener ayuda.',
    clickRefreshButton:
        'Haga clic en el botón Actualizar o vuelva a escribir la dirección web en la barra de direcciones.',
    clickRefreshButtonWithSlowConnection:
        'Haga clic en el botón Actualizar o vuelva a escribir la dirección web en la barra de direcciones. Si todos los sitios web se ejecutan/cargan lentamente, su conexión a Internet puede estar teniendo problemas.',
    retryOrComeBackLater: 'Vuelva a intentar su actividad anterior o vuelva más tarde.',
};

module.exports = {
    name: 'Spanish',
    heading: {
        appTitle: 'Modelo',
    },
    errors: {
        common: {
            helpList: {},
            pleaseTry: 'Por favor intenta lo siguiente:',
        },
        400: {
            header: 'Error 400 (Solicitud Incorrecta)',
            description: 'Estás viendo este mensaje de error porque la dirección web que escribiste es incorrecta.',
            helpList: [
                commonErrorHelpListItems.checkSpellingAndCapitalization,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        401: {
            header: 'Error 401 (No Autorizado)',
            description:
                'Está viendo este mensaje de error porque el nombre de usuario o la contraseña que ingresó son incorrectos.',
            helpList: [
                commonErrorHelpListItems.checkSpellingAndCapitalization,
                'Verifique si la tecla de bloqueo de mayúsculas está ACTIVADA, ya que las contraseñas distinguen entre mayúsculas y minúsculas.',
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        403: {
            header: 'Error 403 (Prohibida)',
            description: 'Está viendo este mensaje de error porque no tiene autorización para acceder a esta página.',
            helpList: [
                commonErrorHelpListItems.checkSpellingAndCapitalization,
                'Asegúrese de que la dirección web apunte a una página web y no a un directorio.',
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        404: {
            header: 'Error 404 (No encontrada)',
            description: 'Estás viendo este mensaje de error porque no pudimos localizar la página que solicitaste.',
            helpList: [
                commonErrorHelpListItems.checkSpellingAndCapitalization,
                commonErrorHelpListItems.clickRefreshButton,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        405: {
            header: 'Error 405 (Método No Permitido)',
            description: 'Está viendo este mensaje de error porque no se pudo completar su solicitud.',
            helpList: [commonErrorHelpListItems.contactSystemAdministratorForAssistance],
        },
        406: {
            header: 'Error 406 (Inaceptable)',
            description: 'Está viendo este mensaje de error porque no se pudo completar su solicitud.',
            helpList: [commonErrorHelpListItems.contactSystemAdministratorForAssistance],
        },
        407: {
            header: 'Error 407 (Se Requiere Autenticación Proxy)',
            description:
                'Está viendo este mensaje de error porque el enlace en el que hizo clic apunta a una página solo para usuarios autorizados.',
            helpList: [
                'Escriba su nombre de usuario/contraseña nuevamente.',
                'Si aún no puede acceder a su cuenta después de volver a intentarlo, comuníquese con el administrador del sistema para obtener ayuda.',
            ],
        },
        408: {
            header: 'Error 408 (Pide Tiempo Fuera)',
            description: 'Está viendo este mensaje de error porque su solicitud tardó demasiado.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                'Intente su solicitud nuevamente más tarde.',
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        409: {
            header: 'Error 409 (Conflicto)',
            description:
                'Está viendo este mensaje de error porque más de una persona puede estar editando un documento compartido al mismo tiempo.',
            helpList: [
                'ESalga del sistema y vuelva a intentar su actividad anterior o regrese más tarde.',
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        500: {
            header: 'Error 500 (Error de Servidor Interno)',
            description: 'Está viendo este mensaje de error porque se ha producido un error desconocido.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                commonErrorHelpListItems.retryOrComeBackLater,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        502: {
            header: 'Error 502 (Malo Gateway)',
            description: 'Está viendo este mensaje de error porque se ha producido un error de red.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                commonErrorHelpListItems.retryOrComeBackLater,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        503: {
            header: 'Error 503 (Servicio No Disponible)',
            description: 'Estás viendo este mensaje de error porque este sitio web no está disponible actualmente.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                commonErrorHelpListItems.retryOrComeBackLater,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        504: {
            header: 'Error 504 (Gateway Acabó el Tiempo)',
            description:
                'Está viendo este mensaje de error porque un servidor está inactivo o no funciona correctamente.',
            helpList: [
                commonErrorHelpListItems.clickRefreshButtonWithSlowConnection,
                commonErrorHelpListItems.retryOrComeBackLater,
                commonErrorHelpListItems.contactSystemAdministratorIfStillUnableToAccess,
            ],
        },
        1800: {
            header: 'La aplicación encontró un error inesperado',
            helpList: [
                commonErrorHelpListItems.clickRefreshButton,
                'Póngase en contacto con el administrador del sistema si aún no puede acceder al sitio web y notifíqueles el error en negrita.',
            ],
        },
    },
    pageFooter: `Este sistema contiene información confidencial que puede estar sujeta a las leyes federales y estatales aplicables.
                 Al acceder a este sistema, deberá cumplir con las leyes aplicables, los términos y condiciones de su
                 acuerdo con HMH y las políticas de su entidad con respecto al uso, transmisión y manejo de tales
                 información confidencial.`,
};
